import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem("usertoken")
  var host = window.location.host

  // host = "wx.rrxue.cn"
  // host = "ks.rrxue.cn"
  host = "wx.sijinjy.cn"
  if (token == undefined) {
    token = ""
    // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1bmlvbmlkIjoiMTE5NDMiLCJ1bmlvbm5hbWUiOiJycnh1ZSIsInN0YWZmaWQiOjAsInN0YWZmbmFtZSI6IiIsInVzZXJyb2xlIjowLCJ1bmlvbnR5cGUiOjAsImlzc3VlciI6InVuaW9uIiwiYXVkaWVuY2UiOiIifQ.JnNcsFz7C1uwEroKw5RrFJUlRSYuqLVL7PO-2s_pqkQ"
    // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE0NjQ5NzEyLCJ1c2VybmFtZSI6Ijk2NjQ2MDZhIiwidW5pb25pZCI6IjUzNjAzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.kZYaOGayYhOWg-wGv16BavziWVvaKTKje129s-89Kmg"
    // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE0NjQ5NzEyLCJ1c2VybmFtZSI6Ijk2NjQ2MDZhIiwidW5pb25pZCI6IjExOTQzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.iS_KMPWMS5y-ojH3zooMBrOrfnmhqwkknGodWWtB8Lk"
  }
  config.params = {
    stamp: new Date().getTime(),
    // host: host,
    token: token,
    ...config.params
  }
  if(process.env.NODE_ENV === 'development') {
    config.params.host = host
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

export const uri = 'https://uapi.233.com'
// export const uri = 'http://192.168.0.164'

export const GetLoginStatus = (params, callback) => get('/UnionInfo/Info/GetLoginStatus', params, callback)// 登陆状态
export const GetFooterByHost = (params, callback) => get('/unioninfo/info/GetFooterByHost', params, callback)// 获取页尾
export const getSeniorFlag = (params, callback) => get('/UnionInfo/Info/GetSeniorFlag', params, callback) //fine/norm
export const Statistics = (params, callback) => get('/UnionInfo/Info/Statistics', params, callback)// cnzz
export const GetKeFuByHost = (params, callback) => get('/unioninfo/info/GetKeFuByHost', params, callback)// 客服

export const GetTitleTimeDaoHang = (params, callback) => get('/unioninfo/BkznPrescription/GetTitleTimeDaoHang', params, callback)// 获取报考指南顶部标题,时间轴，导航与内容(classid 用于辅导老师 辅导课程)
export const HasApp = (params, callback) => get('/unioninfo/info/HasApp', params, callback)// 有定制app
export const GetOtherBkzn = (params, callback) => get('/unioninfo/BkznPrescription/GetOtherBkzn', params, callback)// 获取其他报考指南
export const GetContextById = (params, callback) => get('/unioninfo/BkznPrescription/GetContextById', params, callback)// 根据菜单id获取内容
export const GetCourse = (params, callback) => get('/unioninfo/BkznPrescription/GetCourse', params, callback)// 根据指南内容下的推荐课程
export const GetFudaoCourse = (params, callback) => get('/unioninfo/BkznPrescription/GetFudaoCourse', params, callback)// 辅导课程
export const GetFudaoTeacher = (params, callback) => get('/unioninfo/BkznPrescription/GetFudaoTeacher', params, callback)// 辅导老师

export const get = (api, params, callback) => axios.get(uri + api, {
  params: params
}).then(res => {
  callback(res.data)
})

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
.then(res => {
  callback(res.data)
})